"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApolloProvider = exports.Apollo = void 0;
const lib_env_1 = __importDefault(require("@opsbase/lib-env"));
const Auth_1 = __importDefault(require("@opsbase/react-useauth/Auth"));
const apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
const apollo_client_1 = require("apollo-client");
const apollo_link_1 = require("apollo-link");
const apollo_link_batch_http_1 = require("apollo-link-batch-http");
const apollo_link_serialize_1 = __importDefault(require("apollo-link-serialize"));
const apollo_upload_client_1 = require("apollo-upload-client");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
// ----------------------
// Override FETCH
// ----------------------
// httpOpts allow use to override the default FETCH object with our
// own which automatically adds handles Auth Request and Response Headers
const httpOpts = (forceReal) => ({
    fetch: (uri, options) => __awaiter(void 0, void 0, void 0, function* () {
        options.headers = Object.assign(options.headers || {}, Auth_1.default.getRequestAuthHeaders(forceReal));
        options.headers['Time-Zone'] = (0, moment_timezone_1.default)().utcOffset();
        const res = yield fetch(uri, options);
        if (res.status === 401 && Auth_1.default.hasAuthHeaders()) {
            yield Auth_1.default.api.signOut();
            window.location.href = lib_env_1.default.apis.opsbase;
        }
        yield Auth_1.default.handleHttpResponseHeaders(res.headers, forceReal);
        return res;
    }),
    uri: lib_env_1.default.apis.graphql,
});
// ----------------------
// Set up the Link Chain
// ----------------------
// The link chain basically says:-
//
// 		If context.forceReal = TRUE
//			If context.hasUpload = TRUE
//				serializingLink -> uploadLink_WITH_REAL_AUTH
//			Else
//				serializingLink -> normal_batch_link_WITH_REAL_AUTH
//		Else
//			If context.hasUpload = TRUE
//				serializingLink -> uploadLink_WITH_SHADOWED_AUTH
//			Else
//				serializingLink -> normal_batch_link_WITH_SHADOWED_AUTH
//
const serializingLink = new apollo_link_serialize_1.default();
const makeUploadLinkSplitter = (forceReal) => apollo_link_1.ApolloLink.split(operation => operation.getContext().hasUpload, // every upload mutation has hasUpload true to activate the link
apollo_link_1.ApolloLink.from([serializingLink, (0, apollo_upload_client_1.createUploadLink)(httpOpts(forceReal))]), apollo_link_1.ApolloLink.from([
    serializingLink,
    new apollo_link_batch_http_1.BatchHttpLink(Object.assign(Object.assign({}, httpOpts(forceReal)), { batchMax: 20, batchInterval: 50 })),
]));
const httpLink = apollo_link_1.ApolloLink.split(operation => operation.getContext().forceReal, makeUploadLinkSplitter(true), makeUploadLinkSplitter(false));
// ----------------------
// Create Apollo Client
// ----------------------
exports.Apollo = new apollo_client_1.ApolloClient({
    link: httpLink,
    cache: new apollo_cache_inmemory_1.InMemoryCache(),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'cache-and-network',
            errorPolicy: 'ignore',
        },
        query: {
            fetchPolicy: 'cache-first',
            errorPolicy: 'all',
        },
    },
});
var react_hooks_1 = require("@apollo/react-hooks");
Object.defineProperty(exports, "ApolloProvider", { enumerable: true, get: function () { return react_hooks_1.ApolloProvider; } });
exports.default = exports.Apollo;
